import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Popup from '@/components/Popup/index.jsx';

import imgBg from '@/assets/images/alert/bg.png';
import imglogin from '@/assets/images/alert/labelLogin.png';
import Input from '@/pages/components/input';
import styles from './index.less';

const Login=(props)=>{
  const {destory,className=''} = props;
  const [phone,setPhone] = useState('');
  const [error,setError] = useState('')
  const onOk=()=>{
    if(/\d{11}/.test(phone)){
      destory(phone);
    }else{
      setError('请输入正确的手机号')
    }
  }
  const onClose=()=>{
    destory(false);
  }

  return (
    <section className={styles.center}>
      <section className={`${styles.wrap} ${className}`} >
        <img className={styles.bg} src={imgBg} />
        <img className={styles.imgTitle} src={imglogin} />
        <Input label='手机号码' value={phone} onChange={(v)=>{setError('');setPhone(v)}} error={error} />
        <div onClick={onOk} className={styles.btn}>登录</div>
        <div onClick={onClose} className={styles.close}></div>
      </section>
    </section>
  )
}

const ShowLogin=(props)=>{
  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <Login  destory={popup.destory} />,
      popup.dom
    );
  })
}

export default ShowLogin;